"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderContainer = exports.ButtonContainer = exports.UnsupportedContainer = exports.BuyContainer = exports.Wrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.Wrapper = styled_components_1.default.div `
  width: 100%;
`;
exports.BuyContainer = styled_components_1.default.div `
  width: 100%;
  max-width: 572px;
  max-height: 650px;
  background: white;
  position: relative;

  & > iframe {
    display: block;
    width: 100%;
    min-height: 576px;
    height: 100%;
  }
`;
exports.UnsupportedContainer = styled_components_1.default.div `
  width: 100%;
  max-width: 572px;
  background: white;
  position: relative;
`;
exports.ButtonContainer = styled_components_1.default.div `
  ${({ theme, mercuryo }) => (0, styled_components_1.css) `
    padding: ${mercuryo
    ? `${theme.spacing.unit}px ${theme.spacing.unit}px`
    : `${theme.spacing.unit * 4}px ${theme.spacing.unit * 2}px`};
    background: white;

    & > button {
      width: 100%;
      max-width: unset;
      padding: 0;
      height: 51px;
    }
  `}
`;
exports.LoaderContainer = styled_components_1.default.div `
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`;
//# sourceMappingURL=styled.js.map